<template>
  <div class="left-panel">
    <!-- 商品信息 -->
    <div class="panel-section">
      <h3>商品信息</h3>
      <div class="goods-info">
        <div class="goods-image-placeholder"></div>
        <div class="goods-text">
          <p class="goods-name">这里是商品名称这里是这里是商品名称这里是商品名称...</p>
          <p>SKU1: 1231323</p>
          <p>SKU2: 1231323</p>
        </div>
      </div>
    </div>

    <!-- 已保存方案 -->
    <div class="panel-section">
      <h3>已保存方案</h3>
      <div class="saved-schemes">
        <div class="scheme-item">
          <span>方案名称</span>
          <el-button size="mini" type="danger" icon="el-icon-delete" circle></el-button>
        </div>
        <div class="scheme-item">
          <span>方案名称</span>
          <el-button size="mini" type="danger" icon="el-icon-delete" circle></el-button>
        </div>
      </div>
    </div>

    <!-- 可用模板 -->
    <div class="panel-section">
      <h3>可用模板</h3>
      <div class="template-grid">
        <div class="template-item">文本框</div>
        <div class="template-item">
          <span>模板</span>
          <el-button size="mini" type="danger" icon="el-icon-delete" circle></el-button>
        </div>
        <div class="template-item">水滴模板</div>
      </div>
      <div class="template-grid">
        <div class="template-item">Amazon标签</div>
        <div class="template-item">Rakuten标签</div>
        <div class="template-item">自定义</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LeftPanel'
}
</script>

<style lang="scss" scoped>
// 左侧面板
.left-panel {
  width: 468px;
  background-color: white;
  border-right: 1px solid #e4e7ed;

  overflow-y: auto;

  // 通用面板样式
  .panel-section {
    padding: 30px;
    border-bottom: 1px solid #e4e7ed;

    &:last-child {
      border-bottom: none;
    }

    h3 {

      font-size: 16px;
      color: #333333;
    }
  }

  // 商品信息
  .goods-info {
    display: flex;
    align-items: flex-start;
    margin-top: 24px;

    .goods-image-placeholder {
      width: 150px;
      height: 150px;
      background-color: #e4e7ed;
      margin-right: 12px;
      border-radius: 6px;
    }

    .goods-text {
      flex: 1;
      font-size: 11px;
      color: #606266;
      line-height: 1.4;

      .goods-name {
        font-size: 18px;
        font-weight: normal;
        line-height: 26px;
      }

      p {
        margin: 0 0 4px 0;
        color: #666666;
        font-size: 16px;
        margin-bottom: 12px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  // 已保存方案和模板
  .saved-schemes,
  .template-grid {
    display: flex;
  }

  .scheme-item,
  .template-item {
    display: flex;
    background-color: #F8F4FF;
    border: 1px solid #F8F4FF;
    border-radius: 3px;
    text-align: center;
    font-size: 11px;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 118px;
    height: 78px;
    margin-right: 24px;
    margin-top: 24px;

    &:nth-child(3n) {
      margin-right: 0;
    }


    &:hover {
      border-color: #673ab7;
      background-color: #f0ebff;
    }

    >span {
      flex: 1;
      text-align: center;
    }

    .el-button {
      position: absolute;
      top: 2px;
      right: 2px;
      margin: 0;
    }
  }
}
</style>